import React from "react";
import CustomModalContainer from "../../../../components/modals/CustomModalContainer";
import Button from "../../../ui/Button";
import ModalInput from "../../../ui/ModalTextInput";

interface StepTwoProps {
  open: boolean;
  onClose?: () => void;
  onSuccess?: () => void;
  onDefaultClick?: () => void;
}

const StepTwo: React.FC<StepTwoProps> = ({
  open,
  onClose,
  onSuccess,
  onDefaultClick,
}) => {
  if (!open) return null; // Do not render the component if it's not open

  return (
    <CustomModalContainer
      title="Reset Password"
      footer={
        <div className="flex justify-between relative bottom-0">
          <Button
            type="button"
            onClick={onDefaultClick}
            label="Use as default email"
            layout="inline" variant="ghost"
          />
          <Button
            label="Send code"
            type="submit"
            layout="inline"
            onClick={onSuccess}
          />
        </div>
      }
      open={open}
      onClose={onClose}
    >
      {/* Modal Body */}
      <div className="p-6">
        <div className="text-sm font-semibold text-gray-600">
          Enter an email address below to receive 6 digit OTP code
        </div>
        <ModalInput
          label="Email address"
          type="email"
          placeholder="Enter email address"
          required
        />
      </div>
    </CustomModalContainer>
  );
};

export default StepTwo;
